//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      icon: '',
      icon2: ''
    };
  }
};